import React, { useEffect, useState } from "react";
import { MenuItem } from "../../@types/stores/menu";
import { observer } from "mobx-react";
import "./style.scss";
import {getAllergenById, getHost} from "../../helpers/ApiHelper";
import defaultImg from "../../assets/images/default.webp";
import {OrderLine, OrderLineIngredient, OrderLineIngredients} from "../../@types/stores/order";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useParams } from "react-router";
import IngredientsGroup from "../MenuItem/IngredientsGroup";
import lodash from "lodash";
import orderStore from "../../stores/order";
import { getIngredientsForOrderLine } from "../../helpers/orderHelper";
import { moveToTop } from "../../helpers/DomHelper";
import menuStore from "../../stores/menu";
import useLayoutStyles from "../../hooks/styles";


export interface IngredientsProps {
    item: MenuItem;
    skipRecommendations: boolean;
    isHalfAndHalf?: boolean;
}

const Ingredients = ({item, skipRecommendations, isHalfAndHalf}: IngredientsProps) => {
    const [t] = useTranslation();
    const navigate = useNavigate();
    const params = useParams();
    const location = useLocation();
    const styles = useLayoutStyles();

    const [ingredients, setIngredients] = useState<OrderLineIngredients[]>([]);
    const [allowNext, setAllowNext] = useState<boolean>(true);

    useEffect(() => {
        if (item.ingredientGroups) {
            setDefaultSelectedItems();
        }
        else
            goNext();
    }, []);

    useEffect(() => {
        // if recommendation article
        if (location.pathname.indexOf("/recommendations/") === 0 && typeof params.groupId !== "undefined") {
            menuStore.changeRecommendationGroup(+params.groupId);
        }
    }, [params]);

    useEffect(() => {
        checkAllowNext();
        reCalcOrderLine();
    }, [ingredients]);

    const setDefaultSelectedItems = () => {
        const defaultSelectedGropus = item.ingredientGroups?.filter(ig => ig.items.some(i => !!i.default));
        if (defaultSelectedGropus) {
            const _selected: OrderLineIngredients[] = [];
            defaultSelectedGropus.forEach(ig => {
                _selected.push({
                    groupId: ig.id,
                    items: ig.items.filter(i => !!i.default).map(i => {
                        return {
                            id: i.id,
                            number: i.number,
                            quantity: i.quantity,
                            price: i.unitPrice,
                            sellUnit: i.sellUnit,
                            default: i.default || false
                        };
                    })
                })
            });
            setIngredients(_selected);
        }
    }

    const checkAllowNext = () => {
        let allow = true;

        if (item.ingredientGroups) {
            for (const group of item.ingredientGroups) {
                const selectedCount = ingredients.find(x => x.groupId === group.id)?.items.length || 0;
                const min = group.min || 0;
                if (selectedCount < min)
                    allow = false;
            }
        }

        setAllowNext(allow);
    }

    const changeIngredients = (id: string, selected: OrderLineIngredient[]) => {
        const group = item.ingredientGroups?.find(x => x.id === id);
        if (group) {
            const _ingridients = lodash.cloneDeep(ingredients).filter(x => x.groupId !== id);

            let allowAdd = true;
            if (group.max && selected.length > group.max) {
                allowAdd = false;
            }

            if (allowAdd) {
                _ingridients.push({
                    groupId: id,
                    items: selected
                });
                setIngredients(_ingridients);
            }
        }
    }

    const reCalcOrderLine = () => {
        if (ingredients.length) {
            const orderLine = orderStore.currentOrderLine;
            if (orderLine) {
                const _ingredients = getIngredientsForOrderLine(ingredients, item.ingredientGroups);

                orderLine.ingredients = _ingredients;
                orderStore.setCurrentOrderLine = orderLine;
                orderStore.reCalcCurrentOrderLine();
            }
        }
    }

    const goNext = () => {
        if (!allowNext) return;

        moveToTop();

        if (orderStore.currentOrderLine) {
            if (isHalfAndHalf) {
                if (menuStore.selectedHalfAndHalfStep >= 0) {
                    orderStore.currentOrderLine.count = 0.5;

                    const newArr: OrderLine[] = [...menuStore.selectedHalfAndHalfItems] as OrderLine[];
                    newArr[menuStore.selectedHalfAndHalfStep] = orderStore.currentOrderLine;
                    menuStore.selectedHalfAndHalfItems = newArr;

                    orderStore.currentOrderLine = null;
                }

                navigate(`/menu/halfAndHalf/${menuStore.halfAndHalfNavigation.category}/${menuStore.halfAndHalfNavigation.subCategory}`);
                return;
            }

            orderStore.addToOrder(orderStore.currentOrderLine);
        }

        if (menuStore.returnToScanArticle) {
            navigate("/scanArticle");

            return;
        }

        // from recommendations
        if (skipRecommendations) {
            if (menuStore.navigation.item) {
                const item = menuStore.getItemById(menuStore.navigation.item);

                if (item?.recommendedGroups?.length) {
                    const nextGroupIdIndex = item.recommendedGroups.findIndex(x => x === menuStore.navigation.recommendationGroupId) + 1;
                    if (nextGroupIdIndex && nextGroupIdIndex < item.recommendedGroups.length) {
                        const nextGroupId = item.recommendedGroups.at(nextGroupIdIndex);
                        navigate(`/recommendations/${nextGroupId}`);
                        return;
                    }
                }
            }

            navigate("/menu");
            return;
        }
        navigate("/recommendations");
    }

    if (!item)
        return null;

    return <div className="Ingredients">
        <h2>{item.name}</h2>
        <div className="img" style={{backgroundImage: `url(${item.previewEdit ? `${getHost()}${item.previewEdit}` : (styles?.article.defaultEditImage ? `${getHost()}${styles.article.defaultEditImage}` : defaultImg)}`}} />
        <div className="description">{item.description || ""}</div>
        <div className="allergens">
            {item.allergens?.map(allergenId => getAllergenById(allergenId)?.name || null).filter(name => !!name).map(name => <div key={name} className="allergen">{name}</div>)}
        </div>
        <div className="ingredients">
            {item.ingredientGroups?.length
                ? item.ingredientGroups.map(ig => <IngredientsGroup key={`ingredientsGroup_${ig.id}`} ingredientsGroup={ig} onChange={changeIngredients} selected={ingredients.find(x => x.groupId === ig.id)?.items || []} />)
                : null
            }
        </div>
        <div className={`button dark`} onClick={goNext}>{t(`next`)}</div>
    </div>
}

export default observer(Ingredients);
